export function app() {
    const _window = window;
    if (typeof _window.app !== "undefined") {
        return _window.app;
    }
    throw new Error("The app object in window is undefined");
}
